// components/Testimonials.js
import React from 'react';
import SectionTitle from './SectionTitle';
import Image from '../images/solar-energy.webp';
const TestimonialCard = ({ quote, name, role, image }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-md">
      <div className="flex items-center mb-4">
        <img 
          src={image} 
          alt={name} 
          className="w-16 h-16 rounded-full object-cover mr-4"
        />
        <div>
          <h4 className="font-semibold text-lg">{name}</h4>
          <p className="text-gray-600">{role}</p>
        </div>
      </div>
      <p className="text-gray-700 italic">"{quote}"</p>
    </div>
  );
};

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Kaat Engineering installed our home solar system, and we couldn't be happier with the results. Professional service from start to finish.",
      name: "John Smith",
      role: "Homeowner",
      image: Image
    },
    {
      id: 2,
      quote: "Our business has seen significant savings on our electricity bills since switching to solar with Kaat Engineering. Excellent work!",
      name: "Sarah Johnson",
      role: "Business Owner",
      image: Image
    },
    {
      id: 3,
      quote: "The backup power system has been a lifesaver during outages. The team at Kaat Engineering provided exceptional service.",
      name: "Michael Brown",
      role: "Homeowner",
      image: Image
    }
  ];

  return (
    <section id="testimonials" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="What Our Clients Say" 
          subtitle="Testimonials from satisfied customers"
          centered={true}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <TestimonialCard 
              key={testimonial.id}
              quote={testimonial.quote}
              name={testimonial.name}
              role={testimonial.role}
              image={testimonial.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;